import { useEffect, useState } from "react";
import styled from "styled-components";
import AdminService from "../../services/admin.service";
import * as CommonTypes from "../../types/common.types"
import avatar from '../../assets/common/avatar.svg'
import { format } from "date-fns";
import GeneralInput from "../common/GeneralInput";
import FileInput from "../common/FileInput";
import jsonToFormData from "../../utils/jsonToFormData";
import { useGlobal } from "../../context/global";
import { useAdmin } from "../../context/admin";

export default function Me() {
    const { setIsLoading, setMessage } = useGlobal()
    const { user } = useAdmin()
    const [me, setMe] = useState<CommonTypes.Admin & CommonTypes.Agency & CommonTypes.Owner>({} as any)
    const [agencyData, setAgencyData] = useState<CommonTypes.Agency>({
        display_name: '',
        slogan: '',
        display_phone: '',
        display_email: '',
        emergency_phone: '',
        emergency_whatsapp: '',
        shift_rate_seller: 0,
        shift_rate_admin: 0
    } as CommonTypes.Agency)

    useEffect(() => {
        async function getMe() {
            setIsLoading(true)
            try {
                const response = await (await AdminService.agencyMe()).data
                setMe(response)
                setAgencyData({
                    squared_logo: response.squared_logo || '',
                    variable_logo: response.variable_logo || '',
                    display_name: response.display_name || '',
                    slogan: response.slogan || '',
                    display_phone: response.display_phone || '',
                    display_email: response.display_email || '',
                    emergency_phone: response.emergency_phone || '',
                    emergency_whatsapp: response.emergency_whatsapp || '',
                    shift_rate_seller: response.shift_rate_seller || 0,
                    shift_rate_admin: response.shift_rate_admin || 0
                } as CommonTypes.Agency)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        getMe()
    }, [])

    console.log(me)

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setAgencyData(prev => ({
            ...prev,
            [name]: value
        }))
    }
    // Function to handle file upload with WebP conversion
    const handleFileChange = async (newFile: File, fieldName: keyof CommonTypes.Agency) => {
        setAgencyData(prevData => ({...prevData, [fieldName]: newFile}));
    };
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setIsLoading(true)
        try {
            const formData = jsonToFormData(agencyData)
            const response = await AdminService.editAgencyInfo(formData)
            console.log('Agency updated successfully:', response)
            // Optionally refresh the data
            const updatedMe = await (await AdminService.agencyMe()).data
            setMe(updatedMe)
            setMessage({
                type: 'success',
                content: response.data
            })
            setTimeout(() => {
                setMessage(undefined)
            }, 2500)
        } catch (error) {
            console.error('Error updating agency:', error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Main>
            <Content>
                <div className="pic">
                    <img src={avatar} alt=""/>
                </div>
                <h2>{me.name}</h2>
                {
                    me.agency_id ?
                    <h3>{me.agency_name} | {me.source}</h3>
                    :
                    <h3>{me.source}</h3>
                }
                <h4>ID</h4>
                <h5>{me.id}</h5>
                <h4>Email</h4>
                <h5>{me.email}</h5>
                <h4>Joined at</h4>
                <h5>{me.created_at && format(new Date(me.created_at), 'yyyy/MM/dd h:mm')}</h5>
            </Content>
            {
                user?.user.source !== 'superowners' &&
                <FormContainer onSubmit={handleSubmit}>
                    <h3>Update Agency Information</h3>

                    <FormGrid>
                        <GeneralInput
                            label="Display Name"
                            name="display_name"
                            value={agencyData.display_name}
                            onChange={handleInputChange}
                            placeholder="Enter display name"
                        />

                        <GeneralInput
                            label="Slogan"
                            name="slogan"
                            value={agencyData.slogan}
                            onChange={handleInputChange}
                            placeholder="Enter slogan"
                        />

                        <GeneralInput
                            label="Display Phone"
                            name="display_phone"
                            value={agencyData.display_phone}
                            onChange={handleInputChange}
                            placeholder="Enter display phone"
                        />

                        <GeneralInput
                            label="Display Email"
                            name="display_email"
                            value={agencyData.display_email}
                            onChange={handleInputChange}
                            placeholder="Enter display email"
                            type="email"
                        />

                        <GeneralInput
                            label="Emergency Phone"
                            name="emergency_phone"
                            value={agencyData.emergency_phone}
                            onChange={handleInputChange}
                            placeholder="Enter emergency phone"
                        />

                        <GeneralInput
                            label="Emergency WhatsApp"
                            name="emergency_whatsapp"
                            value={agencyData.emergency_whatsapp}
                            onChange={handleInputChange}
                            placeholder="Enter emergency WhatsApp"
                        />

                        <GeneralInput
                            label="Tarifa por turno — Vendedor"
                            name="shift_rate_seller"
                            type="number"
                            value={agencyData.shift_rate_seller}
                            onChange={handleInputChange}
                            placeholder="15000"
                        />

                        <GeneralInput
                            label="Tarifa por turno — Administrador"
                            name="shift_rate_admin"
                            type="number"
                            value={agencyData.shift_rate_admin}
                            onChange={handleInputChange}
                            placeholder="30000"
                        />

                        <FileInput
                            label="Squared Logo"
                            accept=".png, .jpg, .jpeg, .heic, .webp"
                            value={agencyData.squared_logo}
                            onChange={(newFile: File) => handleFileChange(newFile, 'squared_logo')}
                            deleteFile={() => setAgencyData(prevData => {
                                const { squared_logo, ...rest } = prevData;
                                return rest as CommonTypes.Agency;
                            })}
                            />

                        <FileInput
                            label="Variable Logo"
                            accept=".png, .jpg, .jpeg, .heic, .webp"
                            value={agencyData.variable_logo}
                            onChange={(newFile: File) => handleFileChange(newFile, 'variable_logo')}
                            deleteFile={() => setAgencyData(prevData => {
                                const { variable_logo, ...rest } = prevData;
                                return rest as CommonTypes.Agency;
                            })}
                        />
                    </FormGrid>

                    <SubmitButton type="submit">
                        Update Agency Information
                    </SubmitButton>
                </FormContainer>
            }
        </Main>
    )
}

const Main = styled.div`
width: 100%;
`

const Content = styled.div`
margin: 15px auto;
width: 80%;
padding: 15px;
border-radius: 10px;
box-shadow: 0 0 5px rgba(0,0,0,0.1);
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 10px;
.pic {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    background-color: #FA8072;
    img {
        height: 60%;
        width: 60%;
        object-fit: cover;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
h2 {
    font-size: 18px;
    font-weight: 600;
}
h3 {
    font-size: 14px;
    font-weight: 400;
    color: #777;
}
h4 {
    font-size: 14px;
    font-weight: 400;
    color: #777;
    align-self: flex-start;
}
h5 {
    font-size: 14px;
    font-weight: 400;
    align-self: flex-start;
}
`

const FormContainer = styled.form`
margin: 15px auto;
width: 80%;
padding: 15px;
border-radius: 10px;
box-shadow: 0 0 5px rgba(0,0,0,0.1);
display: flex;
flex-direction: column;
gap: 20px;

h3 {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;
}
`

const FormGrid = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
gap: 15px;
`

const SubmitButton = styled.button`
background-color: #FA8072;
color: white;
border: none;
border-radius: 8px;
padding: 15px 30px;
font-size: 16px;
font-weight: 600;
cursor: pointer;
transition: background-color 0.3s ease;
margin-top: 20px;

&:hover {
    background-color: #e06b5e;
}

&:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}
`